import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';

const FormLanguageSync = () => {
  const { i18n } = useTranslation();
  const {
    resetForm,
    validateForm,
    values,
    setTouched,
    submitCount,           // ← this is the key!
  } = useFormikContext();

  // We track whether validation was ever triggered by user
  const wasSubmitted = useRef(submitCount > 0);

  // Update ref when submitCount changes
  useEffect(() => {
    if (submitCount > 0) {
      wasSubmitted.current = true;
    }
  }, [submitCount]);

  useEffect(() => {
    // Only re-validate if the form was already submitted at least once
    if (!wasSubmitted.current) {
      return;
    }

    (async () => {
      try {
        // 1. Clear previous errors and touched states
        await resetForm({
          values,             // keep current values
          errors: {},         // clear errors
          touched: {},        // clean UX: hide old errors
        });

        // 2. Re-validate → generate new error messages in current language
        const errors = await validateForm();

        // 3. Re-apply touched states for fields that still have errors
        if (Object.keys(errors).length > 0) {
          setTouched(
            Object.keys(errors).reduce((acc, key) => {
              acc[key] = true;
              return acc;
            }, {})
          );
        }
      } catch (err) {
        console.error('Error during language-sync revalidation:', err);
      }
    })();
  }, [
    i18n.language,
    resetForm,
    validateForm,
    values,
    setTouched,
    // We intentionally **don't** depend on submitCount here
    // because we use the ref to avoid unnecessary re-renders
  ]);

  return null;
};

export default FormLanguageSync;